// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__TIYLu","modalForm":"UpgradeEpcsModal_modalForm__35iKC","modalFooter":"UpgradeEpcsModal_modalFooter__3e_VO"};